var _circle, _rect, _rect2, _path, _path2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelDesigner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.4437,
    cy: 47.4437,
    r: 28.1104,
    fill: "#E5E7ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.9117,
    y: 59.3667,
    width: 15.7832,
    height: 15.7832,
    rx: 1.57832,
    stroke: "#152C73",
    strokeWidth: 3.15664
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9835,
    y: 14.5654,
    width: 15.7832,
    height: 15.7832,
    rx: 7.89161,
    transform: "rotate(45 44.9835 14.5654)",
    fill: "#1891F6",
    stroke: "#1891F6",
    strokeWidth: 3.15664
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8031 59.683V49.5818C27.8031 47.8384 29.2164 46.4251 30.9597 46.4251H58.7382C60.4816 46.4251 61.8949 47.8384 61.8949 49.5818V58.736",
    stroke: "#152C73",
    strokeWidth: 3.15664
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8488 35.0618L44.8488 46.4258",
    stroke: "#152C73",
    strokeWidth: 3.15664
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2267,
    y: 54.3333,
    width: 18.9399,
    height: 18.9399,
    rx: 3.15664,
    transform: "rotate(45 62.2267 54.3333)",
    fill: "#1891F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelDesigner);
export default __webpack_public_path__ + "static/media/model-designer.e89d268b87545d9334568cf291a99be9.svg";
export { ForwardRef as ReactComponent };